import { createElement } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";

// Programmatic confirm() method
export function confirm({ message, title, showCancel, titleConfirm, titleCancel }) {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);
    const cleanup = () => {
      setTimeout(() => {
        root.unmount();
        container.remove();
      }, 10);
    };
    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };
    const handleCancel = () => {
      cleanup();
      resolve(false);
    };
    root.render(
      createElement(ConfirmModal, {
        open: true,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        message,
        title,
        showCancel,
        titleConfirm,
        titleCancel,
      })
    );
  });
}

export function ConfirmModal({ open, onConfirm, onCancel, message, title, showCancel, titleConfirm, titleCancel }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <Modal
      show={true}
      close={onCancel}
      action={
        <>
          {showCancel && (
            <button className="white" onClick={onCancel}>
              {titleCancel || t("common.cancel")}
            </button>
          )}
          <button className="blue ml-10" onClick={onConfirm}>
            {titleConfirm || t("common.confirm")}
          </button>
        </>
      }
      size="small"
      title={title}
    >
      {message}
    </Modal>
  );
}
